import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { ExtractivesApp } from './ExtractivesApp';

const rootElement = document.getElementById('extractives-form-root');

if (!rootElement) {
  throw new Error('Missing #extractives-form-root element');
}

if (typeof stepFormAppSettings === 'undefined') {
  throw new Error('Missing stepFormAppSettings inline script');
}

createRoot(rootElement).render(
  <StrictMode>
    <ExtractivesApp settings={stepFormAppSettings} />
  </StrictMode>
);
